export const PROVISIONAL_HIGH_VOLUME_PRICE_CENTS = 129900;

export const VOLUME_SLIDER_STOPS = Object.freeze([
  0, 1000, 2500, 5000, 10000, 25000, 50000, 100000, 150000,
]);

export const VOLUME_SLIDER_LABELS = Object.freeze([
  "0",
  "1k",
  "2.5k",
  "5k",
  "10k",
  "25k",
  "50k",
  "100k",
  "100k+",
]);

export const VOLUME_BANDS = Object.freeze([
  Object.freeze({ key: "ORDERS_0_1000", min: 0, max: 1000, priceCents: 9900 }),
  Object.freeze({
    key: "ORDERS_1001_2500",
    min: 1001,
    max: 2500,
    priceCents: 14900,
  }),
  Object.freeze({
    key: "ORDERS_2501_5000",
    min: 2501,
    max: 5000,
    priceCents: 19900,
  }),
  Object.freeze({
    key: "ORDERS_5001_10000",
    min: 5001,
    max: 10000,
    priceCents: 29500,
  }),
  Object.freeze({
    key: "ORDERS_10001_25000",
    min: 10001,
    max: 25000,
    priceCents: 49900,
  }),
  Object.freeze({
    key: "ORDERS_25001_50000",
    min: 25001,
    max: 50000,
    priceCents: 79900,
  }),
  Object.freeze({
    key: "ORDERS_50001_100000",
    min: 50001,
    max: 100000,
    priceCents: 129900,
  }),
  Object.freeze({
    key: "ORDERS_100001_PLUS",
    min: 100001,
    max: null,
    priceCents: PROVISIONAL_HIGH_VOLUME_PRICE_CENTS,
    customQuote: true,
  }),
]);

export const getVolumeBand = (averageMonthlyOrders) => {
  const volume = Math.max(0, Number(averageMonthlyOrders || 0));
  return (
    VOLUME_BANDS.find((band) => band.max === null || volume <= band.max) ||
    VOLUME_BANDS[VOLUME_BANDS.length - 1]
  );
};

export const volumeSliderPositionToOrders = (position) => {
  const index = Math.min(VOLUME_SLIDER_STOPS.length - 2, Math.floor(position));
  const progress = position - index;

  return Math.round(
    VOLUME_SLIDER_STOPS[index] +
      (VOLUME_SLIDER_STOPS[index + 1] - VOLUME_SLIDER_STOPS[index]) * progress
  );
};

export const ordersToVolumeSliderPosition = (orders) => {
  const value = Math.max(0, Math.min(150000, Number(orders || 0)));
  const upperIndex = VOLUME_SLIDER_STOPS.findIndex((stop) => stop >= value);

  if (upperIndex <= 0) return 0;

  const lower = VOLUME_SLIDER_STOPS[upperIndex - 1];
  const upper = VOLUME_SLIDER_STOPS[upperIndex];

  return upperIndex - 1 + (value - lower) / (upper - lower);
};

export const formatVolumeBand = (band) =>
  band.max === null
    ? "Above 100,000"
    : `${band.min.toLocaleString("en-US")}–${band.max.toLocaleString("en-US")}`;
